import { getQueryString } from '@mx/util/get-query-string';
import { init as neoInit } from '@mx/neo';
import { compareVersion } from '@mx/util/compare-version';
import { CreditType, env } from '@/common';

export function initPage(url?: string) {
  const isMock = process.env.NODE_ENV === 'development';
  // 解析 query 统计参数
  const neoStatParams = {
    nb_version: getQueryString('app_pay_sdk_version'),
    nb_platform: getQueryString('device_platform'),
    last_resumed_page: getQueryString('last_resumed_page'),
    is_debug: getQueryString('is_debug'),
  };
  const prefetchKeyList = [];
  if (url) {
    prefetchKeyList.push(url);
  }
  const config = {
    mock: isMock,
    mode: 'CSR' as const,
    // paramsValidator: (params: Record<string, any>): boolean => params && typeof params === 'object'
    // && ['usr_token', 'pay_token', 'tradeno', 'extra_data']
    //   .every((k) => params[k] !== null && params[k] !== undefined),
    prefetchKeyList, // 预请求的接口列表
    statBasicParams: {
      ...neoStatParams,
      project: 'com.sankuai.fspfepayresource.paydefer',
      neo_scene: 'com.sankuai.fspfepayresource.paydefer',
    },
    mapStatBasicParams: (params: NeoCashierParams) => ({
      // trade_no: params.tradeno,
      // merchant_no: params.merchant_no || '',
      last_resumed_page: params.last_resumed_page || '',
    }),
  };
  return neoInit<NeoCashierParams>(config).then((neoRawParams: NeoCashierParams) => {
    let rawParams = neoRawParams;
    if (isMock) {
      // 增加 extra_data 数据
      rawParams = {
        ...rawParams,
        extra_data: JSON.stringify({
          scorePlanId: '3481',
          creditType: CreditType.WeiXin,
          // payType: PayType.WeiXin,
          // authNo: '1111',
          // oncePayMultipleOrders: '1',
        }),
      };
    }
    console.log('rawParams::', rawParams);

    // 设置 env
    env.setInpayBasicBusinessParams(rawParams);
    env.setCommonParams(rawParams);
    env.setStatCommonParams(rawParams);
    env.setSpecialNeoInitParams(rawParams);
    env.setMemberId(rawParams);

    const useNewCashierCallback =
      env.specialNeoInitParams.promotion_degrade_switch === 'open' &&
      compareVersion(env.commonParams.sdk_version, '9.8.0') >= 0;
    env.setUseNewCashierCallback(useNewCashierCallback);
    const enableNsf = !!(
      compareVersion(env.commonParams.sdk_version, '11.5.0') >= 0 && env.specialNeoInitParams.enable_nsf === '1'
    );
    env.setEnableNsf(enableNsf);

    // vconsole 测试用
    setTimeout(() => {
      console.log('从参数隧道接收到的所有参数----,', rawParams);
    }, 1000);
    return rawParams;
  });
}
